// Configuration for EventPopupManager component
export const createEventPopupManagerConfig = ({
    // Main event popup state
    isOpen,
    setOpen,
    isEdit,
    isManualSaving,
    anchor,
    
    // Event data
    popupEventTitle,
    popupEventDescription,
    popupEventAllDay,
    popupEventDate,
    popupEventTime,
    popupEventCreated,
    popupEventEdited,
    selectedColor,
    availability,
    showAvailabilitySelect,
    isX,
    isEditable,
    isChecked,
    
    // Event handlers
    saveEvent,
    onClose,
    onDelete,
    onAvailabilityChange,
    onHandleEventXChange,
    onHandleEventInvoicedChange,
    titleChange,
    descriptionChange,
    allDayChange,
    changeStartDate,
    changeEndDate,
    handleResourceCheckInEvent,
    changeColor,
    
    // UI configuration
    headerText,
    popupButtons,
    responsivePopup,
    
    // References
    startRef,
    endRef,
    
    // Hover popup state
    isHoverOpen,
    hoverIsBusy,
    hoverIsVacation,
    isHoverDayOpen,
    
    // Holiday popup state
    holidayAnchor,
    holidayName,
    
    // Event handlers for hover/holiday
    onMouseEnter,
    onMouseLeave,
    onHolidayMouseEnter,
    onHolidayMouseLeave,
    
    // Resources and utilities
    resources,
    flattenArr,
    getDateFromTimestamp,
    eventContent
}) => ({
    // Main event popup
    isOpen,
    setOpen,
    isEdit,
    isManualSaving,
    saveEvent,
    onClose,
    headerText,
    anchor,
    onDelete,
    onAvailabilityChange,
    onHandleEventXChange,
    onHandleEventInvoicedChange,
    popupEventTitle,
    titleChange,
    popupEventDescription,
    descriptionChange,
    selectedColor,
    availability,
    showAvailabilitySelect,
    isX,
    isEditable,
    popupEventAllDay,
    allDayChange,
    popupEventDate,
    changeStartDate,
    changeEndDate,
    startRef,
    endRef,
    isChecked,
    handleResourceCheckInEvent,
    popupButtons,
    responsivePopup,
    changeColor,
    
    // Hover popup
    isHoverOpen,
    hoverIsBusy,
    hoverIsVacation,
    popupEventTime,
    popupEventCreated,
    popupEventEdited,
    eventContent,
    onMouseEnter,
    onMouseLeave,
    
    // Holiday popup
    isHoverDayOpen,
    holidayAnchor,
    holidayName,
    onHolidayMouseEnter,
    onHolidayMouseLeave,
    
    // Resources and utilities
    resources,
    flattenArr,
    getDateFromTimestamp
});
